import { render, staticRenderFns } from "./BaseContentEditable.vue?vue&type=template&id=8c44ca48&scoped=true"
import script from "./BaseContentEditable.vue?vue&type=script&lang=js"
export * from "./BaseContentEditable.vue?vue&type=script&lang=js"
import style0 from "./BaseContentEditable.vue?vue&type=style&index=0&id=8c44ca48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c44ca48",
  null
  
)

export default component.exports